import React from "react";

//firebase
import { db } from 'assets/firebase';

//algolia full text search
import { algolia } from 'assets/algolia';

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CartProductAdded, CartCleared } from 'redux/actions';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "assets/jss/material-kit-pro-react/views/ecommerceSections/productsStyle.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Accordion from "components/Accordion/Accordion.jsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "components/CustomButtons/Button.jsx";

// icons
import Cached from "@material-ui/icons/Cached";
import Check from "@material-ui/icons/Check";
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';

//kekaha
import ProductDetails from "components/ProductDetails/ProductDetails.jsx";


function compareName(a,b) {

  var aName = a.Name;
  var bName = b.Name;
  
  if (aName < bName)
      return -1;
  if (aName > bName)
      return 1;
  return 0;
}

var sort_by;

(function() {
    // utility functions
    var default_cmp = function(a, b) {
            if (a === b) return 0;
            return a < b ? -1 : 1;
        },
        getCmpFunc = function(primer, reverse) {
            var dfc = default_cmp, // closer in scope
                cmp = default_cmp;
            if (primer) {
                cmp = function(a, b) {
                    return dfc(primer(a), primer(b));
                };
            }
            if (reverse) {
                return function(a, b) {
                    return -1 * cmp(a, b);
                };
            }
            return cmp;
        };

    // actual implementation
    sort_by = function() {
        var fields = [],
            n_fields = arguments.length,
            field, name, cmp;

        // preprocess sorting options
        for (var i = 0; i < n_fields; i++) {
            field = arguments[i];
            if (typeof field === 'string') {
                name = field;
                cmp = default_cmp;
            }
            else {
                name = field.name;
                cmp = getCmpFunc(field.primer, field.reverse);
            }
            fields.push({
                name: name,
                cmp: cmp
            });
        }

        // final comparison function
        return function(A, B) {
            var name, result;
            for (var i = 0; i < n_fields; i++) {
                result = 0;
                field = fields[i];
                name = field.name;

                result = field.cmp(A[name].toUpperCase(), B[name].toUpperCase());
                if (result !== 0) break;
            }
            return result;
        }
    }
}());

class SectionProducts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: [],
      priceRange: [101, 790],
      products: [],
      visibleProducts: [],
      categories: [],
      selectedEnabled:"",
      resultsCount: 0,
      collapseAccordion: false,
      lastKnownCustomerID: ""
    };

    var cartTotal = 0.00;
    for(var j = 0; j < props.cart.length; j++) {
      cartTotal = cartTotal + (props.cart[j].qty * props.cart[j].listPrice);
    }

    this.state.cartTotal = cartTotal;

    this.resetFilters = this.resetFilters.bind(this);
    this.refreshProducts = this.refreshProducts.bind(this); 
    this.handleChangeEnabled = this.handleChangeEnabled.bind(this);  
    
  }

  componentDidMount() {

    var categories = [
      { id: "1", Name: "Shirts" },
      { id: "2", Name: "Journals" },
      { id: "3", Name: "Posters" }
    ]

    this.setState({categories: categories, selectedEnabled: categories[0].id }, () => {
      this.refreshProducts();
    });
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.searchQuery) {
      this.setState({query: nextProps.searchQuery}, () => {
        this.resetFilters();
      });
    }

    if(nextProps.cart) {

      var cartTotal = 0.00;
      for(var j = 0; j < nextProps.cart.length; j++) {
        cartTotal = cartTotal + (nextProps.cart[j].qty * nextProps.cart[j].listPrice);
      }

      this.setState({cartTotal: cartTotal});
    }
  }

  resetFilters(category) {
    if(!category) {
      category = null;
    }

    this.setState({checked: [], selectedEnabled:category }, () => {
      this.refreshProducts();
    });
  }

  refreshProducts() {

    var query = '';
    var category = null;

    // ignore category when searching w/ text
    if(this.state.query) {
      query = this.state.query;
      this.setState({collapseAccordion: true}, () => {
        this.setState({collapseAccordion: false});
      });
    } else {
      category = this.state.selectedEnabled;
      this.setState({collapseAccordion: false});
    }

    console.log('query: ' + query + ", category: " + category)
    algolia.searchProducts(query, category).then(results => {
    
      console.log('results');
      console.log(results);
      
      var filtered = [];
      
      for(var i = 0; i < results.length; i++) {
      
        if(this.props.visibility) {
          
          var isHidden = false;
          for(var v = 0; v < this.props.visibility.length; v++) {
            if(this.props.visibility[v].productID === results[i].id) {
              isHidden = true;
              break;
            }
          }
        }
        
        if(!isHidden) {
          
          // set image property
          if(!results[i].thumbnail) {
            results[i].thumbnail = "/missingImage.jpg";
          }
          if(!results[i].photo) {
            results[i].photo = "/missingImage.jpg";
          }

          if(!results[i].attachments)
            results[i].attachments = [];

          filtered.push(results[i]);
        } 
      }
    
      this.setState({resultsCount: filtered.length, products: filtered});
      
    });
    
  }

  trim(value, maxLength) {
    if(value) {
        if(value.trim().length > maxLength)
            return value.trim().substring(0,maxLength) + "...";
        else
            return value.trim();
    } else return "";
  }


  handleChangeEnabled(event) { // category
    //this.props.resetQuery();
    this.setState({ query:"", selectedEnabled: event.target.value }, () => {
      this.refreshProducts();
    }); 
  }


  resultsCount () {
    if(this.state.resultsCount === 50) {
      return <span>more than 50 matching products found</span>
    } else {
      return <span>{this.state.resultsCount} matching products found</span>
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container} >
      
        <GridContainer style={{marginTop:"23px"}}>
          <GridItem md={3} sm={3}>
            
            <Accordion
              active={0}
              activeColor="primary"
              collapse={this.state.collapseAccordion}
              collapses={[
                {
                  title: "Categories",
                  content: (
                    <div>
                      {this.state.categories.map((category,index) => (
                        <div key={index}>
                          <FormControlLabel
                            control={
                              
                              <Radio
                                checked={this.state.selectedEnabled === category.id}
                                onChange={this.handleChangeEnabled}
                                value={category.id}
                                name={category.Name}
                                icon={<FiberManualRecord className={classes.radioUnchecked}/>}
                                checkedIcon={<FiberManualRecord className={classes.radioChecked}/>}
                                classes={{
                                  checked: classes.radio,
                                  root: classes.radioRoot
                                }}
                              />
                            }
                            classes={{ label: classes.label }}
                            label={category.Name}
                            style={{marginTop:"-17px", marginLeft:"0px"}}
                          />
                        </div>
                      ))}
                    </div>
                  )
                }
              ]} 
            />
            <div style={{fontSize:"12px", color:"#DF8F43", fontWeight:"400", display:"none"}}>
                {this.resultsCount()} 
            </div>
            <br />
            <div style={{textAlign:"center", marginBottom:"30px", display:"none"}}>
              <Tooltip
                id="tooltip-top"
                title="Reset Filter"
                placement="top"
                classes={{ tooltip: classes.tooltip }}
              >
                <Button
                  link
                  size="sm"
                  className={`${ classes.refineButton }`}
                  onClick={() => this.resetFilters(this.state.categories[0].id)}
                >
                  <Cached /> Clear Filters
                </Button>
              </Tooltip>
            </div>
          </GridItem>
          <GridItem md={9} sm={9}>
            <GridContainer>
                <GridItem xs={12}>
                  
                </GridItem>
                {this.state.products.map((product,index) => (
                  <ProductDetails product={product} key={product.id} />
                ))}
              </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({onCartProductAdded: CartProductAdded, onCartCleared: CartCleared }, dispatch);  
}

SectionProducts = connect(mapStateToProps, mapDispatchToProps)(SectionProducts);
export default withStyles(styles)(SectionProducts);



// WEBPACK FOOTER //
// ./src/views/EcommercePage/Sections/SectionProducts.jsx